export const modalNewTermsShowVersionLink: boolean = true;
